<template>
  <div>
    <div class="page-title-container lighter-shadow">
      <i class="fas fa-sitemap icon"></i>
      <h1 v-text="teamOverview.name" v-if="!isTeamLoading"></h1>
    </div>
    <TabContainer :tabs="tabs"/>
    <div class="page-content lighter-shadow">
      <div class="tab-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import redirectService from "@/services/redirect.service";
import {mapGetters} from 'vuex';
import TabContainer from "@/shared/components/TabContainer";

export default {
  name: "TeamOverview",
  components: {TabContainer},
  created() {
    if (this.$route.path === '/teams/' + this.teamId) {
      redirectService.redirectToTeam(this.teamId);
      return;
    }

    this.$store.dispatch('fetchTeam', this.teamId);
  },
  data() {
    return {
      teamId: this.$route.params.id,
      tabs: [
        {
          id: 'TeamOverview',
          link: 'overview',
          name: 'Преглед',
          icon: 'fas fa-info-circle',
        },
        {
          id: 'TeamMembers',
          link: 'staff',
          name: 'Състав',
          icon: 'fas fa-users'
        }
      ],
    }
  },
  computed: {
    ...mapGetters(['teamOverview', 'isTeamLoading']),
  },
  destroyed() {
    this.$store.commit('setTeamOverview', {});
  }
}
</script>

<style scoped>
@import '../../css/shared/tabs.css';

.tab-content {
  width: 100%;
  float: left;
  box-sizing: border-box;
  padding: 25px;
}
</style>
